import React from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function TiltCard({ logo, color, link, width=200, height=100 }) {
  // valeurs de la souris
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  // lissage
  const config = { stiffness: 200, damping: 20 };
  const smoothX = useSpring(x, config);
  const smoothY = useSpring(y, config);

  // conversion des mouvements en degrés (-15° à 15°)
  const rotateY = useTransform(smoothX, [-width / 2, width / 2], [15, -15]);
  const rotateX = useTransform(smoothY, [-height / 2, height / 2], [-15, 15]);

  function handleMouseMove(e) {
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = e.clientX - (rect.left + rect.width / 2);
    const offsetY = e.clientY - (rect.top + rect.height / 2);

    x.set(offsetX);
    y.set(offsetY);
  }

  function handleMouseLeave() {
    x.set(0);
    y.set(0);
  }

  return (
    <div
      style={{
        perspective: 100,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <motion.div
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          width,
          height,
          borderRadius: 20,
          background: color,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",

          // animation rotation
          rotateX,
          rotateY,

          // nécessaire pour 3D
          transformStyle: "preserve-3d",
        }}
      >
        <img onClick={() => window.open(link)} src={logo}/>
      </motion.div>
    </div>
  );
}
